import UserHandler from "js/utilities/user-handler"
import Api from "js/utilities/fnapi-client"

export default {

  fetchRecentStats: function(callback) {
    var end = Math.round(Date.now()/1000);
    var start = (end - 86400).toString();
    end = end.toString();

    let data = {
      start: start,
      end: end
    };

    return Api.get("reports/auth-token/stats",data);
  },

  //fetchRecentAuths: function(callback) {
  //  return Api.get("reports/zoom/stat",);
  //},

  // fetchSDKStats: function(time, callback) {
  //   let data = {};
  //   if (time === "all") {
  //     data.start = 0;
  //     var end = Math.round(Date.now()/1000);
  //     data.end = end.toString()
  //   }
  //   return Api.get("reports/zoom/stats",data);
  // },

  fetchSDKStats: function(start, end, callback) {
    let data = {};
    if (start != "" && end != "") {
      data.start = start
      data.end = end
    }
    return Api.get("reports/zoom/stats",data);
  }
};



// WEBPACK FOOTER //
// ./src/js/stores/stats-store.jsx